/* Video-card grid + modal player. Generic, multi-instance safe, no deps.
   One card click = one modal with a native <video controls autoplay>.
   ESC / backdrop / X close it and tear the player down (stops playback). */
(function () {
  function init(root) {
    if (root.dataset.gsvReady) return;
    root.dataset.gsvReady = "1";
    var modal = root.querySelector("[data-gsv-modal]");
    var titleEl = root.querySelector("[data-gsv-modal-title]");
    var playerBox = root.querySelector("[data-gsv-player]");
    var lastFocus = null;

    function close() {
      modal.hidden = true;
      playerBox.innerHTML = "";
      if (lastFocus) lastFocus.focus();
    }

    function open(card) {
      lastFocus = card;
      titleEl.textContent = card.getAttribute("data-gsv-title") || "";
      playerBox.innerHTML = "";
      var src = card.getAttribute("data-gsv-src");
      if (src) {
        var v = document.createElement("video");
        v.src = src;
        v.controls = true;
        v.autoplay = true;
        v.playsInline = true;
        var poster = card.getAttribute("data-gsv-poster");
        if (poster) v.poster = poster;
        playerBox.appendChild(v);
      } else {
        var img = document.createElement("img");
        img.src = card.getAttribute("data-gsv-poster") || "";
        img.alt = "";
        img.style.cssText = "width:100%;height:100%;object-fit:cover;display:block";
        playerBox.appendChild(img);
      }
      modal.hidden = false;
      var closeBtn = modal.querySelector("[data-gsv-close]");
      if (closeBtn) closeBtn.focus();
    }

    root.querySelectorAll("[data-gsv-open]").forEach(function (card) {
      card.addEventListener("click", function () { open(card); });
    });
    modal.addEventListener("click", function (e) { if (e.target === modal) close(); });
    var x = modal.querySelector("[data-gsv-close]");
    if (x) x.addEventListener("click", close);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !modal.hidden) close();
    });
  }

  function initAll() {
    document.querySelectorAll("[data-gs-videos]").forEach(init);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initAll);
  else initAll();
  document.addEventListener("shopify:section:load", initAll);
})();
